import { useNavigate } from "react-router-dom"
import { Typography } from "@mui/material"

import StyledPaper from "/components/paper"

import managementImage from '/assets/dashboard/management.png'

const AccountManagement = () => {

  const navigate = useNavigate()

  return (
    <StyledPaper width={250} height={250}>
      <div onClick={() => navigate("/account-management")} className="link flex flex-col items-center justify-top h-full">
        <Typography variant="h6">Account Management</Typography>
      </div>
      <div onClick={() => navigate("/account-management")} className="link relative">
        <img src={managementImage} style={{ position: "absolute", left: "50%", bottom: 10, height: "170px", display: "inline-block", transform: "translateX(-50%)", filter: "drop-shadow(0 8px 12px rgba(0, 0, 0, 0.5))" }} />
      </div>
    </StyledPaper>
  )
}

export default AccountManagement